(function() {
  // ─── Config ──────────────────────────────────────────────────────────────
  const API_BASE = 'https://returns-portal-worker.erel-162.workers.dev';

  // ─── State ───────────────────────────────────────────────────────────────
  let orderData = null;
  let selectedItems = {};

  const STEPS = [
    { num: 1, label: 'בחירת פריט/ים' },
    { num: 2, label: 'פירוט' },
    { num: 3, label: 'סיכום ואישור' },
    { num: 4, label: 'סיום התהליך' },
  ];

  const REASONS = [
    { code: 'wrong_size', label: 'מידה לא מתאימה', followups: ['גדול מדי', 'קטן מדי'] },
    { code: 'not_as_expected', label: 'המוצר לא כצפוי', followups: [] },
    { code: 'defective', label: 'פגם במוצר', followups: [], requirePhoto: true },
    { code: 'changed_mind', label: 'שינוי דעת', followups: [] },
    { code: 'wrong_item', label: 'התקבל פריט שגוי', followups: [] },
    { code: 'other', label: 'אחר', followups: [] },
  ];

  // ─── Init ────────────────────────────────────────────────────────────────

  const params = new URLSearchParams(window.location.search);
  const trackReturn = params.get('return');
  if (trackReturn) {
    goToScreen('screenTracker');
    loadReturnStatus(trackReturn);
  }

  // ─── Screen Navigation ──────────────────────────────────────────────────

  window.goToScreen = function(screenId) {
    document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
    document.getElementById(screenId).classList.add('active');
    window.scrollTo(0, 0);
  };

  function renderStepper(containerId, activeStep) {
    const el = document.getElementById(containerId);
    if (!el) return;
    el.innerHTML = STEPS.map((s, i) => {
      const state = s.num < activeStep ? 'done' : s.num === activeStep ? 'active' : '';
      const lineState = s.num < activeStep ? 'done' : '';
      const circle = '<div class="step-item"><div class="step-circle ' + state + '">' + (state === 'done' ? '✓' : s.num) + '</div><div class="step-label ' + state + '">' + s.label + '</div></div>';
      const line = i < STEPS.length - 1 ? '<div class="step-line ' + lineState + '"></div>' : '';
      return circle + line;
    }).join('');
  }

  // ─── Step 0: Lookup ─────────────────────────────────────────────────────

  window.lookupOrder = async function() {
    const orderNum = document.getElementById('orderNumber').value.trim();
    const email = document.getElementById('customerEmail').value.trim();
    const errorEl = document.getElementById('lookupError');
    const btn = document.getElementById('lookupBtn');

    errorEl.classList.remove('visible');

    if (!orderNum || !email) {
      errorEl.textContent = 'נא להזין מספר הזמנה וכתובת אימייל';
      errorEl.classList.add('visible');
      return;
    }

    btn.disabled = true;
    btn.innerHTML = 'מחפש... <span class="spinner"></span>';

    try {
      const res = await fetch(API_BASE + '/lookup-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_number: orderNum, email: email }),
      });

      const data = await res.json();

      if (!res.ok) {
        errorEl.textContent = data.error || 'שגיאה בחיפוש';
        errorEl.classList.add('visible');
        return;
      }

      orderData = data;
      selectedItems = {};
      renderItemsScreen();
      goToScreen('screenItems');

    } catch (err) {
      errorEl.textContent = 'שגיאה בחיבור לשרת. נסי שוב.';
      errorEl.classList.add('visible');
    } finally {
      btn.disabled = false;
      btn.textContent = 'הבא';
    }
  };

  // Allow Enter key
  var emailInput = document.getElementById('customerEmail');
  if (emailInput) {
    emailInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') lookupOrder();
    });
  }

  // ─── Step 1: Select Items ──────────────────────────────────────────────

  function renderItemsScreen() {
    renderStepper('stepper', 1);
    var container = document.getElementById('itemsList');

    container.innerHTML = orderData.items.map(function(item) {
      var priceDisplay = (item.price / 100).toFixed(2);
      var isEligible = item.eligible;

      return '<div class="item-card ' + (!isEligible ? 'ineligible' : '') + '" id="item-' + item.line_item_id + '">' +
        '<div class="item-header">' +
          (item.image ? '<img class="item-image" src="' + item.image + '" alt="">' : '<div class="item-image"></div>') +
          '<div class="item-info">' +
            '<div class="item-title">' + item.product_title + '</div>' +
            '<div class="item-variant">' + (item.variant_title || '') + '</div>' +
          '</div>' +
          '<div class="item-price">₪ ' + priceDisplay + '</div>' +
        '</div>' +
        (!isEligible ? '<div class="item-ineligible-reason">' + item.ineligible_reason + '</div>' :
          '<div class="action-selector" id="action-' + item.line_item_id + '">' +
            '<button class="action-toggle" onclick="toggleActionMenu(\'' + item.line_item_id + '\')">' +
              '<span>בחירה</span>' +
              '<span class="arrow">▸</span>' +
            '</button>' +
            '<div class="action-dropdown" id="dropdown-' + item.line_item_id + '">' +
              '<button class="action-option" onclick="selectAction(\'' + item.line_item_id + '\', \'exchange\')">' +
                '<span>החלפת מידה / צבע (ללא עלות)</span>' +
              '</button>' +
              '<button class="action-option" onclick="selectAction(\'' + item.line_item_id + '\', \'refund\')">' +
                '<span>החזרה</span>' +
              '</button>' +
            '</div>' +
          '</div>'
        ) +
      '</div>';
    }).join('');
  }

  window.toggleActionMenu = function(lineItemId) {
    var toggle = document.querySelector('#action-' + lineItemId + ' .action-toggle');
    var dropdown = document.getElementById('dropdown-' + lineItemId);

    if (toggle.classList.contains('chosen')) return;

    toggle.classList.toggle('open');
    dropdown.classList.toggle('open');
  };

  window.selectAction = function(lineItemId, actionType) {
    var item = orderData.items.find(function(i) { return i.line_item_id === lineItemId; });
    var toggle = document.querySelector('#action-' + lineItemId + ' .action-toggle');
    var dropdown = document.getElementById('dropdown-' + lineItemId);
    var card = document.getElementById('item-' + lineItemId);

    selectedItems[lineItemId] = {
      line_item_id: item.line_item_id,
      product_id: item.product_id,
      product_handle: item.product_handle,
      product_title: item.product_title,
      variant_id: item.variant_id,
      variant_title: item.variant_title,
      sku: item.sku,
      image: item.image,
      price: item.price,
      item_type: actionType,
      reason: null,
      reason_detail: null,
      reason_followup: null,
      condition: 'unopened',
      exchange_variant_id: null,
      exchange_variant_title: null,
      exchange_variant_price: null,
      exchange_variant_sku: null,
      exchange_variant_image: null,
    };

    var label = actionType === 'exchange' ? 'החלפת מידה / צבע (ללא עלות)' : 'החזרה';
    toggle.innerHTML = '<span>' + label + '</span><span class="arrow">▸</span>';
    toggle.classList.add('chosen');
    toggle.classList.remove('open');
    dropdown.classList.remove('open');
    card.classList.add('selected');

    var existing = document.querySelector('#action-' + lineItemId + ' .action-reset');
    if (!existing) {
      var resetLink = document.createElement('div');
      resetLink.className = 'action-reset';
      resetLink.textContent = 'איפוס בחירה';
      resetLink.onclick = function() { resetAction(lineItemId); };
      document.getElementById('action-' + lineItemId).appendChild(resetLink);
    }

    updateNextButton();
  };

  window.resetAction = function(lineItemId) {
    delete selectedItems[lineItemId];
    var toggle = document.querySelector('#action-' + lineItemId + ' .action-toggle');
    var card = document.getElementById('item-' + lineItemId);

    toggle.innerHTML = '<span>בחירה</span><span class="arrow">▸</span>';
    toggle.classList.remove('chosen', 'open');
    card.classList.remove('selected');

    var reset = document.querySelector('#action-' + lineItemId + ' .action-reset');
    if (reset) reset.remove();

    updateNextButton();
  };

  function updateNextButton() {
    document.getElementById('nextToDetailBtn').disabled = Object.keys(selectedItems).length === 0;
  }

  // ─── Step 2: Detail ────────────────────────────────────────────────────

  window.goToDetail = function() {
    renderStepper('stepper2', 2);
    var container = document.getElementById('detailContent');
    var items = Object.values(selectedItems);

    container.innerHTML = items.map(function(item) {
      var priceDisplay = (item.price / 100).toFixed(2);

      if (item.item_type === 'exchange') {
        return '<div class="item-card selected">' +
          '<div class="item-header">' +
            (item.image ? '<img class="item-image" src="' + item.image + '" alt="">' : '<div class="item-image"></div>') +
            '<div class="item-info">' +
              '<div class="item-title">' + item.product_title + '</div>' +
              '<div class="item-variant">' + (item.variant_title || '') + '</div>' +
            '</div>' +
            '<div class="item-price">₪ ' + priceDisplay + '</div>' +
          '</div>' +
          '<div class="exchange-picker" id="picker-' + item.line_item_id + '">' +
            '<div style="text-align: center; color: #888; padding: 20px;">טוען אפשרויות...</div>' +
          '</div>' +
        '</div>';
      } else {
        return '<div class="reason-section" id="reason-' + item.line_item_id + '">' +
          '<div class="item-header" style="margin-bottom: 12px;">' +
            (item.image ? '<img class="item-image" src="' + item.image + '" alt="">' : '<div class="item-image"></div>') +
            '<div class="item-info">' +
              '<div class="item-title">' + item.product_title + '</div>' +
              '<div class="item-variant">' + (item.variant_title || '') + '</div>' +
            '</div>' +
          '</div>' +
          '<select class="reason-select" onchange="selectReason(\'' + item.line_item_id + '\', this.value)">' +
            '<option value="">בחרי סיבה להחזרה</option>' +
            REASONS.map(function(r) { return '<option value="' + r.code + '">' + r.label + '</option>'; }).join('') +
          '</select>' +
          '<div class="reason-followup" id="followup-' + item.line_item_id + '"></div>' +
          '<textarea class="reason-detail" id="detail-' + item.line_item_id + '" placeholder="פירוט נוסף (אופציונלי)" oninput="updateReasonDetail(\'' + item.line_item_id + '\', this.value)"></textarea>' +
        '</div>';
      }
    }).join('');

    items.filter(function(i) { return i.item_type === 'exchange'; }).forEach(function(item) {
      loadVariants(item);
    });

    goToScreen('screenDetail');
  };

  window.selectReason = function(lineItemId, reasonCode) {
    selectedItems[lineItemId].reason = reasonCode;

    var reason = REASONS.find(function(r) { return r.code === reasonCode; });
    var followupEl = document.getElementById('followup-' + lineItemId);

    if (reason && reason.followups && reason.followups.length) {
      followupEl.innerHTML = reason.followups.map(function(f) {
        return '<button class="followup-btn" onclick="selectFollowup(\'' + lineItemId + '\', this, \'' + f + '\')">' + f + '</button>';
      }).join('');
    } else {
      followupEl.innerHTML = '';
    }
  };

  window.selectFollowup = function(lineItemId, btn, value) {
    var buttons = btn.parentElement.querySelectorAll('.followup-btn');
    for (var i = 0; i < buttons.length; i++) buttons[i].classList.remove('active');
    btn.classList.add('active');
    selectedItems[lineItemId].reason_followup = value;
  };

  window.updateReasonDetail = function(lineItemId, value) {
    selectedItems[lineItemId].reason_detail = value;
  };

  async function loadVariants(item) {
    var pickerEl = document.getElementById('picker-' + item.line_item_id);

    try {
      var handle = item.product_handle || await getProductHandle(item.product_id);
      if (!handle) {
        pickerEl.innerHTML = '<div style="text-align: center; color: #c00;">לא ניתן לטעון אפשרויות להחלפה</div>';
        return;
      }

      var res = await fetch(API_BASE + '/product-variants/' + handle);
      var data = await res.json();

      if (!res.ok || !data.variants || !data.variants.length) {
        pickerEl.innerHTML = '<div style="text-align: center; color: #c00;">אין אפשרויות זמינות להחלפה</div>';
        return;
      }

      var available = data.variants.filter(function(v) { return v.available && String(v.id) !== item.variant_id; });

      pickerEl.innerHTML =
        '<input type="text" class="picker-search" placeholder="חיפוש" oninput="filterVariants(\'' + item.line_item_id + '\', this.value)">' +
        '<div class="picker-count">' + available.length + ' מתוך ' + data.total_variants + ' הפריטים זמינים במלאי</div>' +
        '<div id="variants-list-' + item.line_item_id + '">' +
          renderVariantsList(item.line_item_id, available) +
        '</div>';

      pickerEl._variants = available;

    } catch (err) {
      pickerEl.innerHTML = '<div style="text-align: center; color: #c00;">שגיאה בטעינת אפשרויות</div>';
    }
  }

  function renderVariantsList(lineItemId, variants) {
    return variants.map(function(v) {
      var priceDisplay = (v.price / 100).toFixed(2);
      var isSelected = selectedItems[lineItemId] && selectedItems[lineItemId].exchange_variant_id === v.id;

      return '<div class="variant-card ' + (isSelected ? 'selected' : '') + '" onclick="selectVariant(\'' + lineItemId + '\', \'' + v.id + '\', \'' + (v.title || '').replace(/'/g, "\\'") + '\', ' + v.price + ', \'' + (v.sku || '') + '\', \'' + (v.image || '') + '\')">' +
        (v.image ? '<img class="variant-image" src="' + v.image + '" alt="">' : '<div class="variant-image"></div>') +
        '<div class="variant-info">' +
          '<div class="variant-option">צבע ' + (v.option1 || '') + '</div>' +
          '<div class="variant-size">מידה ' + (v.option2 || v.title) + '</div>' +
        '</div>' +
        '<div class="variant-price">₪ ' + priceDisplay + '</div>' +
      '</div>';
    }).join('');
  }

  window.filterVariants = function(lineItemId, query) {
    var pickerEl = document.getElementById('picker-' + lineItemId);
    var variants = pickerEl._variants || [];
    var filtered = query
      ? variants.filter(function(v) { return (v.title + ' ' + (v.option1 || '') + ' ' + (v.option2 || '')).indexOf(query) !== -1; })
      : variants;

    document.getElementById('variants-list-' + lineItemId).innerHTML = renderVariantsList(lineItemId, filtered);
  };

  window.selectVariant = function(lineItemId, variantId, title, price, sku, image) {
    var item = selectedItems[lineItemId];
    item.exchange_variant_id = variantId;
    item.exchange_variant_title = title;
    item.exchange_variant_price = price;
    item.exchange_variant_sku = sku;
    item.exchange_variant_image = image;

    var pickerEl = document.getElementById('picker-' + lineItemId);
    if (pickerEl._variants) {
      document.getElementById('variants-list-' + lineItemId).innerHTML = renderVariantsList(lineItemId, pickerEl._variants);
    }

    renderPriceSummary(lineItemId);
  };

  function renderPriceSummary(lineItemId) {
    var item = selectedItems[lineItemId];
    if (!item || item.item_type !== 'exchange' || !item.exchange_variant_price) return;

    var oldPrice = item.price;
    var newPrice = item.exchange_variant_price;
    var diff = newPrice - oldPrice;

    var existingSummary = document.getElementById('price-summary-' + lineItemId);
    if (existingSummary) existingSummary.remove();

    var summaryHtml =
      '<div class="price-summary" id="price-summary-' + lineItemId + '">' +
        '<div class="price-row"><span>שווי הפריטים שהוחזרו/הוחלפו</span><span>₪ ' + (oldPrice / 100).toFixed(2) + '</span></div>' +
        (diff !== 0 ? '<div class="price-row"><span>פריטים חדשים שנבחרו</span><span>₪ ' + (newPrice / 100).toFixed(2) + '-</span></div>' : '') +
        '<div class="price-row total"><span>סה"כ לתשלום:</span><span>₪ ' + Math.max(0, diff / 100).toFixed(2) + '</span></div>' +
      '</div>';

    var picker = document.getElementById('picker-' + lineItemId);
    picker.insertAdjacentHTML('afterend', summaryHtml);
  }

  async function getProductHandle(productId) {
    try {
      var res = await fetch('https://' + window.location.hostname + '/products.json?product_id=' + productId);
      var data = await res.json();
      return data.products && data.products[0] ? data.products[0].handle : null;
    } catch (e) {
      return null;
    }
  }

  // ─── Step 3: Summary ───────────────────────────────────────────────────

  window.goToSummary = function() {
    var items = Object.values(selectedItems);
    var errorEl = document.getElementById('detailError');

    var missingReason = items.find(function(i) { return i.item_type === 'refund' && !i.reason; });
    if (missingReason) {
      errorEl.textContent = 'נא לבחור סיבה להחזרה לכל הפריטים';
      errorEl.classList.add('visible');
      return;
    }

    var missingVariant = items.find(function(i) { return i.item_type === 'exchange' && !i.exchange_variant_id; });
    if (missingVariant) {
      errorEl.textContent = 'נא לבחור מידה/צבע חלופי לכל פריטי ההחלפה';
      errorEl.classList.add('visible');
      return;
    }

    errorEl.classList.remove('visible');
    renderStepper('stepper3', 3);

    var container = document.getElementById('summaryContent');
    var totalRefund = 0;
    var totalExchangeDiff = 0;

    var itemsHtml = items.map(function(item) {
      var priceDisplay = (item.price / 100).toFixed(2);
      var badge = item.item_type === 'exchange'
        ? '<span class="summary-badge badge-exchange">החלפה</span>'
        : '<span class="summary-badge badge-refund">החזרה</span>';

      if (item.item_type === 'refund') {
        totalRefund += item.price;
        var reason = REASONS.find(function(r) { return r.code === item.reason; });
        return '<div class="summary-card"><div class="summary-item">' +
          (item.image ? '<img class="item-image" src="' + item.image + '" alt="">' : '') +
          '<div class="item-info">' +
            '<div class="item-title">' + item.product_title + ' ' + badge + '</div>' +
            '<div class="item-variant">' + (item.variant_title || '') + ' — ₪ ' + priceDisplay + '</div>' +
            '<div class="item-variant">סיבה: ' + (reason ? reason.label : item.reason) + (item.reason_followup ? ' (' + item.reason_followup + ')' : '') + '</div>' +
          '</div></div></div>';
      } else {
        var diff = (item.exchange_variant_price || 0) - item.price;
        totalExchangeDiff += diff;
        return '<div class="summary-card"><div class="summary-item">' +
          (item.image ? '<img class="item-image" src="' + item.image + '" alt="">' : '') +
          '<div class="item-info">' +
            '<div class="item-title">' + item.product_title + ' ' + badge + '</div>' +
            '<div class="item-variant">' + (item.variant_title || '') + ' → ' + (item.exchange_variant_title || '') + '</div>' +
          '</div></div></div>';
      }
    }).join('');

    var summaryHtml = itemsHtml +
      '<div class="price-summary">' +
        (totalRefund > 0 ? '<div class="price-row"><span>סה"כ החזר</span><span>₪ ' + (totalRefund / 100).toFixed(2) + '</span></div>' : '') +
        (totalExchangeDiff !== 0 ? '<div class="price-row"><span>הפרש החלפה</span><span>₪ ' + (totalExchangeDiff / 100).toFixed(2) + '</span></div>' : '') +
        '<div class="price-row total"><span>סה"כ</span><span>₪ ' + (Math.max(0, totalExchangeDiff - totalRefund) / 100).toFixed(2) + '</span></div>' +
      '</div>';

    container.innerHTML = summaryHtml;
    document.getElementById('termsCheck').checked = false;
    updateSubmitBtn();

    goToScreen('screenSummary');
  };

  window.updateSubmitBtn = function() {
    document.getElementById('submitBtn').disabled = !document.getElementById('termsCheck').checked;
  };

  // ─── Step 4: Submit ────────────────────────────────────────────────────

  window.submitReturn = async function() {
    var btn = document.getElementById('submitBtn');
    var errorEl = document.getElementById('summaryError');
    errorEl.classList.remove('visible');

    btn.disabled = true;
    btn.innerHTML = 'שולח... <span class="spinner"></span>';

    try {
      var submitItems = Object.values(selectedItems).map(function(item) {
        return {
          line_item_id: item.line_item_id,
          product_id: item.product_id,
          product_handle: item.product_handle,
          product_title: item.product_title,
          variant_id: item.variant_id,
          variant_title: item.variant_title,
          sku: item.sku,
          image: item.image,
          quantity: 1,
          price: item.price,
          item_type: item.item_type,
          reason: item.reason || 'exchange',
          reason_detail: item.reason_detail,
          reason_followup: item.reason_followup,
          condition: item.condition,
          exchange_variant_id: item.exchange_variant_id,
          exchange_variant_title: item.exchange_variant_title,
          exchange_variant_price: item.exchange_variant_price,
          exchange_variant_sku: item.exchange_variant_sku,
          exchange_variant_image: item.exchange_variant_image,
        };
      });

      var res = await fetch(API_BASE + '/submit-return', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order: orderData.order, items: submitItems }),
      });

      var data = await res.json();

      if (!res.ok) {
        errorEl.textContent = data.error || 'שגיאה בשליחה';
        errorEl.classList.add('visible');
        return;
      }

      renderResult(data);

    } catch (err) {
      errorEl.textContent = 'שגיאה בחיבור לשרת. נסי שוב.';
      errorEl.classList.add('visible');
    } finally {
      btn.disabled = false;
      btn.textContent = 'שליחה';
    }
  };

  function renderResult(data) {
    renderStepper('stepper4', 4);

    var isApproved = data.status === 'approved' || data.status === 'label_created';

    document.getElementById('resultContent').innerHTML =
      '<div class="result-icon">' + (isApproved ? '✅' : '⏳') + '</div>' +
      '<div class="result-title">' + (isApproved ? 'הבקשה אושרה!' : 'הבקשה בבדיקה') + '</div>' +
      '<div class="result-subtitle">' + (isApproved
        ? 'בקשת ההחזרה שלך אושרה. אנא הדפיסי את תווית המשלוח ושלחי את הפריטים.'
        : 'בקשת ההחזרה שלך התקבלה ונמצאת בבדיקה. נחזור אלייך בהקדם.'
      ) + '</div>' +
      '<div class="return-number-display">' + data.return_number + '</div>' +
      (data.hfd_label_url ? '<a class="label-link" href="' + data.hfd_label_url + '" target="_blank">📄 הדפסת תווית משלוח</a>' : '') +
      (data.hfd_tracking ? '<p style="text-align: center; color: #888; font-size: 13px;">מספר מעקב: ' + data.hfd_tracking + '</p>' : '') +
      '<div class="btn-row" style="margin-top: 24px;">' +
        '<a class="btn-primary" href="?return=' + data.return_number + '" style="text-decoration: none; text-align: center;">מעקב סטטוס</a>' +
      '</div>';

    goToScreen('screenResult');
  }

  // ─── Status Tracker ────────────────────────────────────────────────────

  async function loadReturnStatus(returnNumber) {
    var container = document.getElementById('trackerContent');
    container.innerHTML = '<div style="text-align: center; padding: 40px; color: #888;">טוען...</div>';

    try {
      var res = await fetch(API_BASE + '/return-status/' + returnNumber);
      var data = await res.json();

      if (!res.ok) {
        container.innerHTML = '<div style="text-align: center; color: #c00; padding: 20px;">' + (data.error || 'לא נמצאה') + '</div>';
        return;
      }

      var timelineHtml = data.history.map(function(h, i) {
        var isLast = i === data.history.length - 1;
        var date = new Date(h.created_at * 1000);
        var dateStr = date.toLocaleDateString('he-IL') + ' ' + date.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' });
        return '<li class="timeline-item">' +
          '<div class="timeline-dot ' + (isLast ? 'current' : 'active') + '"></div>' +
          '<div class="timeline-content">' +
            '<div class="timeline-status">' + h.status_label + '</div>' +
            '<div class="timeline-date">' + dateStr + '</div>' +
            (h.note ? '<div class="timeline-note">' + h.note + '</div>' : '') +
          '</div>' +
        '</li>';
      }).join('');

      var typeBadge = data.return_type === 'exchange' ? 'badge-exchange' : 'badge-refund';
      var typeLabel = data.return_type === 'exchange' ? 'החלפה' : (data.return_type === 'mixed' ? 'מעורב' : 'החזרה');

      container.innerHTML =
        '<div class="return-number-display">' + data.return_number + '</div>' +
        '<div style="text-align: center; margin-bottom: 16px;">' +
          '<span class="summary-badge ' + typeBadge + '">' + typeLabel + '</span>' +
        '</div>' +
        '<ul class="timeline">' + timelineHtml + '</ul>' +
        (data.hfd_tracking_number ? '<p style="text-align: center; font-size: 13px; color: #888;">מספר מעקב משלוח: ' + data.hfd_tracking_number + '</p>' : '') +
        (data.hfd_label_url ? '<a class="label-link" href="' + data.hfd_label_url + '" target="_blank">📄 תווית משלוח</a>' : '') +
        (data.hfd_exchange_tracking ? '<p style="text-align: center; font-size: 13px; color: #888;">מעקב משלוח החלפה: ' + data.hfd_exchange_tracking + '</p>' : '');
    } catch (err) {
      container.innerHTML = '<div style="text-align: center; color: #c00; padding: 20px;">שגיאה בטעינת סטטוס</div>';
    }
  }

})();
